import React, { useEffect, useState } from 'react';
import { FaExchangeAlt } from 'react-icons/fa';
import inversionesExteriorService from '../../services/inversionesExteriorService';
import useYearSelector from '../../hooks/useYearSelector';
import YearSelector from '../../components/common/YearSelector';
import TablaTiposCambio from '../../components/InversionesExterior/TablaTiposCambio';
import { showError } from '../../utils/alerts';
import '../../styles/pages/InversionesExterior/TiposCambio.css';

/**
 * Tipos de cambio al 31-12 (solo lectura)
 * Las tasas son comunes a todas las empresas y las registra EFE en el panel de
 * administración. Con ellas se pasan a pesos los montos en otra moneda.
 */
const TiposCambioPage = ({ token }) => {
    const { selectedYear, setSelectedYear, yearOptions } = useYearSelector(null, 2, 0);
    const [tasas, setTasas] = useState(null);

    useEffect(() => {
        const buscar = async () => {
            setTasas(null);
            try {
                setTasas(await inversionesExteriorService.getTiposCambio(selectedYear, token));
            } catch (error) {
                showError('No se pudieron obtener los tipos de cambio', error.message);
            }
        };
        buscar();
    }, [selectedYear, token]);

    return (
        <div className="invext-tc-container">
            <div className="invext-tc-header">
                <h1><FaExchangeAlt /> Tipos de cambio</h1>
                <p>Tasas al 31-12 con que se pasan a pesos los montos en otra moneda</p>
            </div>

            <div className="invext-tc-seccion">
                <div className="invext-tc-anio">
                    <YearSelector
                        selectedYear={selectedYear}
                        onYearChange={setSelectedYear}
                        yearOptions={yearOptions}
                        label="Año de los movimientos"
                    />
                    <p className="invext-tc-ayuda">
                        Los movimientos de {selectedYear} se declaran en el AT {selectedYear + 1}.
                    </p>
                </div>

                {tasas === null ? null : tasas.length === 0 ? (
                    <p className="invext-tc-aviso">
                        Todavía no hay tasas registradas para {selectedYear}. Las registra EFE en el panel de administración.
                    </p>
                ) : (
                    <TablaTiposCambio tasas={tasas} />
                )}
            </div>
        </div>
    );
};

export default TiposCambioPage;
